import PropTypes from 'prop-types';

export default {
  isBreach: PropTypes.bool,
  isCpp: PropTypes.bool,
  isFreeTrial: PropTypes.bool,
  isPartner: PropTypes.bool,
  productIdentifier: PropTypes.string,
};
